import React from 'react';

const Footer = () => (
    
    <footer>
        <div className="footer-made-by">
          <div className="made-by">
            <span>© 2021</span>
            <a href="https://egorkabantsov.netlify.app" rel="noreferrer nofollow" target="_blank" className="made-by-link"><span>Created by </span>Egor Kabantsov</a>
          </div>
        </div>
    </footer>
);

export default Footer;

